import { CollapseOutlined, TickCircleOutlined } from "@aircall/icons";
import {
  Box,
  Button,
  Dropdown,
  Icon,
  Menu,
  Spacer,
  Tooltip,
  Typography,
} from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import SentimentHappyGrey from "@/assets/images/sentiment_happy_grey.svg?react";
import SmsConversationFill from "@/assets/images/sms_conversation_fill.svg?react";

import {
  DropdownMenuItemProps,
  TimelineModePickerProps,
  timelineMode,
} from ".";

function DropdownMenuItem({
  children,
  active,
  onClick,
  "data-test": dataTest,
}: DropdownMenuItemProps) {
  return (
    <Spacer
      onClick={onClick}
      data-test={dataTest}
      p="xxs s"
      justifyContent="space-between"
      fluid
      cursor="pointer"
    >
      <Spacer gap="xxs" alignItems="center">
        {children}
      </Spacer>
      {active && <TickCircleOutlined color="primary-500" />}
    </Spacer>
  );
}

function PickIcon({ mode }: Pick<TimelineModePickerProps, "mode">) {
  switch (mode) {
    case timelineMode.simple:
      return <CollapseOutlined />;
    case timelineMode.karaoke:
      return <SmsConversationFill />;
    case timelineMode.sentiments:
      return <SentimentHappyGrey />;
    default:
      return null;
  }
}

export function TimelineModePicker({
  mode,
  onClickSimple,
  onClickKaraoke,
  onClickSentiments,
}: TimelineModePickerProps) {
  const { t } = useTranslation();

  return (
    <Dropdown
      maxWidth="min-content"
      trigger={
        <Box>
          <Tooltip title={t("change_view")}>
            <Button
              mode="ghost"
              size="small"
              variant="secondary"
              data-test="time-line-mode-picker-button"
            >
              <PickIcon mode={mode} />
            </Button>
          </Tooltip>
        </Box>
      }
    >
      <Menu>
        <Box p="xxs s">
          <Typography variant="bodySemiboldS">{t("view")}</Typography>
        </Box>
        <DropdownMenuItem
          onClick={onClickSimple}
          active={mode === "simple"}
          data-test="simple-mode-timeline-button"
        >
          <CollapseOutlined color="icon-default" />
          <Typography variant="bodyRegularS">{t("simple")}</Typography>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={onClickKaraoke}
          active={mode === "karaoke"}
          data-test="karaoke-mode-timeline-button"
        >
          <Icon component={SmsConversationFill} color="icon-default" />
          <Typography variant="bodyRegularS">{t("karaoke")}</Typography>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={onClickSentiments}
          active={mode === "sentiments"}
          data-test="sentiment-mode-timeline-button"
        >
          <Icon component={SentimentHappyGrey} color="icon-default" />
          <Typography variant="bodyRegularS">{t("emotions")}</Typography>
        </DropdownMenuItem>
      </Menu>
    </Dropdown>
  );
}
